const Separator: React.FC = () => {
    return (
            <div className='flex'>
                <div className='border h-10 border-toolbar-separator1'></div>
                <div className='border h-10 border-toolbar-separator2'></div>
            </div>
    )
}

export default Separator